export default __webpack_public_path__ + "static/Concrete-Parking-Lot-Removal-29f22ddb4c37afc41e35d0c1ab4a7d91.jpg";